<script>
export const group = 'TopLeft'
</script>

<script setup>
import Clock from '../kijk_live_qmusic_nl_default/Clock.vue'
</script>

<template>
  <Clock key="clock" class="font-bold-pixels" />
</template>
